import React from "react";
import {Panel, useStore} from "@xyflow/react";
import {Paper, Typography} from "@mui/material";
import type {TaxonomyCanvasNode} from "~/prototypes/pages/taxonomy-canvas/taxonomyCanvasLayout.ts";
import {CurrencyComponent} from "~/components/currency-component/CurrencyComponent.tsx";

/** Below this zoom level the card titles are too small to read */
const SHOW_BELOW_ZOOM = 0.7;

type Props = {
    node: TaxonomyCanvasNode | undefined
    /** Names of the categories above the node, L1 first */
    parents: string[]
}
/** Shows the hovered category in a readable size while the canvas is zoomed out. Render inside `<ReactFlow>`. */
export const HoveredNodePanel: React.FC<Props> = ({node, parents}) => {
    const zoomedOut = useStore(s => s.transform[2] < SHOW_BELOW_ZOOM);
    if (!node || !zoomedOut) return null;
    const {data} = node;
    return <Panel position="top-left">
        <Paper variant="outlined" sx={{px: 1.5, py: 1, maxWidth: 360, borderColor: 'mithraBlue.300', boxShadow: 2}}>
            {parents.length > 0 && <Typography variant="caption" color="mithraBlue.800" sx={{opacity: 0.7}} noWrap component="div">
                {parents.join(' › ')}
            </Typography>}
            <Typography variant="subtitle2" fontWeight={700} color="mithraBlue.800">
                {data.label}
            </Typography>
            <Typography variant="caption" color="mithraBlue.800" component="div">
                {data.level === 0 ? 'Taxonomy' : `L${data.level}`}
                {' · '}<CurrencyComponent v={data.spend} nDigits={3}/>
                {data.childCount > 0 && ` · ${data.childCount} sub-categories`}
            </Typography>
        </Paper>
    </Panel>
}
